import { jsx as a, jsxs as w } from "react/jsx-runtime";
import { IressStack as j } from "../../../components/Stack/Stack.js";
import { useState as y, useEffect as u, useRef as I, useMemo as T } from "react";
import { IressProgress as k } from "../../../components/Progress/Progress.js";
import { c as M } from "../../../index-2QXL0WYc.js";
import { l as n } from "../../../Loading.module-Bs6DSfb4.js";
import { IressText as v } from "../../../components/Text/Text.js";
import { propagateTestid as O } from "../../../helpers/utility/propagateTestid.js";
import { useShowIndicator as E } from "../hooks/useShowIndicator.js";
import { useEstimatedProgressValue as R } from "../hooks/useEstimatedProgressValue.js";
const H = "ids-start-up-loading--root-v5150", P = "ids-start-up-loading--progress-v5150", h = {
  root: H,
  progress: P
}, U = ({
  children: g,
  messageList: e,
  progressValue: c,
  screenReaderText: s,
  show: t,
  ...l
}) => {
  const o = I(null), d = T(() => {
    const r = Object.keys(e ?? {}).filter(
      (f) => Number(f) <= c
    );
    return r[r.length - 1];
  }, [e, c]);
  u(() => {
    o.current && (o.current.classList.remove(n["slide-next"]), o.current.offsetHeight, o.current.classList.add(n["slide-next"]));
  }, [d]);
  const p = t ? g : s;
  return /* @__PURE__ */ a(
    v,
    {
      align: "center",
      className: M(h.message, n["fade-in"], {
        [n["fade-in--active"]]: t
      }),
      ...l,
      children: /* @__PURE__ */ a("div", { ref: o, children: d ? e == null ? void 0 : e[Number(d)] : p })
    }
  );
}, K = ({
  className: g,
  children: e = /* @__PURE__ */ a(v, { mode: "muted", children: "One moment please..." }),
  "data-testid": c,
  estimatedFinishTime: s = 3e3,
  loaded: t,
  messageList: l,
  progress: o,
  renderProgress: d = (m) => /* @__PURE__ */ a(k, { ...m }),
  screenReaderText: p = "Loading...",
  timeout: r,
  ...f
}) => {
  const m = E(
    t,
    r == null ? void 0 : r.progress,
    r == null ? void 0 : r.loaded
  ), [x, N] = y(!1), S = Math.max(...Object.keys(l ?? {}).map(Number)) + 500, i = R(
    s,
    t,
    o,
    S
  );
  return u(() => {
    const b = setTimeout(
      () => N(!0),
      (r == null ? void 0 : r.message) ?? 2500
    );
    return () => {
      clearTimeout(b);
    };
  }, [r == null ? void 0 : r.message]), /* @__PURE__ */ a(
    "div",
    {
      "data-testid": c,
      className: M(h.root, g, n["fade-in"], {
        [n["fade-in--active"]]: m
      }),
      ...f,
      children: /* @__PURE__ */ w(j, { gutter: "md", ...f, children: [
        d({
          className: h.progress,
          min: 0,
          max: s,
          value: Math.min(i, s),
          sectionTitle: `${Math.min(i, s) / s * 100}% loaded`
        }),
        /* @__PURE__ */ a(
          U,
          {
            "data-testid": O(c, "message"),
            messageList: l,
            progressValue: i,
            screenReaderText: p,
            show: x,
            children: e
          }
        )
      ] })
    }
  );
};
export {
  K as StartUpLoading
};
